
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Callout, Flex } from '@radix-ui/themes';
import React from 'react';

const Unauthorized: React.FC = () => {

    return (
        <Flex direction="column">
            <Callout.Root color="red" role="alert">
                <Callout.Icon>
                    <ExclamationTriangleIcon />
                </Callout.Icon>
                <Callout.Text>
                    Acesso negado!
                </Callout.Text>
            </Callout.Root>

        </Flex>

    );
};

export default Unauthorized;